import { render, staticRenderFns } from "./cookiePrivadidad.vue?vue&type=template&id=8166a714&scoped=true"
import script from "./cookiePrivadidad.vue?vue&type=script&lang=js"
export * from "./cookiePrivadidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8166a714",
  null
  
)

export default component.exports